export type Ticket = {
  comment: {
    body: string;
  };
  subject: string;
  priority: string;
  tags: string[];
};

export function generateReturnAssetTicket(
  workingOfficeCountry,
  officeName,
  officeCountry,
  employeeNumber,
  assetName,
  assetSerialNumber,
  reason
): Ticket {
  return {
    comment: {
      body: `Hi Team,\nSerial Number: ${assetSerialNumber}\nDevice Name: ${assetName}\nReason: ${reason}`,
    },
    subject: `Return Hardware request by emp ID ${employeeNumber}, ${officeName} ${officeCountry}`,
    priority: "normal",
    tags: [
      "myTW",
      "myTW_Return_Hardware_Assigned_To_Me",
      `Assign_To_Workspaces_${workingOfficeCountry}`,
    ],
  };
}

export function generateReportAccessoryIssueTicket(
  workingOfficeCountry,
  officeName,
  officeCountry,
  employeeNumber,
  accessoryName,
  issue
): Ticket {
  return {
    comment: {
      body: `Hi Team,\nAccessory: ${accessoryName}\nIssue description: ${issue}`,
    },
    subject: `Accessory issue by emp ID ${employeeNumber}, ${officeName} ${officeCountry}`,
    priority: "normal",
    tags: [
      "myTW",
      "myTW_Report_Accessory_Issues",
      `Assign_To_Workspaces_${workingOfficeCountry}`,
    ],
  };
}

export function generateHardwareIssueTicket(
  workingOfficeCountry,
  officeName,
  officeCountry,
  employeeNumber,
  assetName,
  assetSerialNumber,
  repairType,
  issue
): Ticket {
  return {
    comment: {
      body: `Hi Team,\nSerial Number: ${assetSerialNumber}\nDevice name: ${assetName}\nIssue: ${issue}`,
    },
    subject: `Hardware issue by emp ID ${employeeNumber}, ${officeName} ${officeCountry}`,
    priority: "normal",
    tags: [
      "myTW",
      "myTW_Report_Hardware_Issues",
      `Assign_To_Workspaces_${workingOfficeCountry}`,
      repairType.toLowerCase().split(" ").join("_"),
    ],
  };
}

export function generateHardwareNotListedIssueTicket(
  workingOfficeCountry,
  officeName,
  officeCountry,
  employeeNumber,
  hardwareSpecification,
  additionalInfo
): Ticket {
  return {
    comment: {
      body: `Hi Team,\nHardware Specification: ${hardwareSpecification}${
        additionalInfo ? `\nAdditional Information: ${additionalInfo}` : ""
      }`,
    },
    subject: `Hardware not listed in myTW for emp ID ${employeeNumber}, ${officeName} ${officeCountry}`,
    priority: "normal",
    tags: [
      "myTW",
      "myTW_Report_Hardware_Not_Listed",
      `Assign_To_Workspaces_${workingOfficeCountry}`,
    ],
  };
}

export function generateRequestTicket(
  workingOfficeCountry,
  officeName,
  officeCountry,
  employeeNumber,
  itemRequested,
  isRequestForProject,
  additionalInfo,
  requestType
): Ticket {
  return {
    comment: {
      body: `Hi Team,\n${requestType} Requested: ${itemRequested}\nIs the request for a project: ${isRequestForProject}${
        additionalInfo ? `\nAdditional Information: ${additionalInfo}` : ""
      }`,
    },
    subject: `${requestType} request by emp ID ${employeeNumber}, ${officeName} ${officeCountry}`,
    priority: "normal",
    tags: [
      "myTW",
      `myTW_Request_${requestType}`,
      `Assign_To_Workspaces_${workingOfficeCountry}`,
    ],
  };
}
